<template>
  <button
    type="button"
    class="inner_item"
    :disabled="isEditMode"
    @click="onSortItemClick"
  >
    <span style="display: inline-block">
      <slot />
    </span>
    <template v-if="isEditMode">
      <i
        v-if="sortColumn === columnName"
        class="sort_icon icon icon--sorting-white"
        :class="{ asc: isSortAsc }"
      ></i>
    </template>
    <button
      v-else
      class="sort"
      :class="{
        asc: sortColumn === columnName && isSortAsc,
        desc: sortColumn === columnName && !isSortAsc,
        active: sortColumn === columnName
      }"
    >
      <i class="icon icon--sort-asc"></i>
      <i class="icon icon--sort-desc"></i>
    </button>
  </button>
</template>

<script>
export default {
  name: 'SortOptions',
  props: ['columnName', 'sortColumn', 'isSortAsc', 'isEditMode'],
  data () {
    return {}
  },
  methods: {
    onSortItemClick () {
      const columnName = this.columnName
      let isAsc = true

      if (this.sortColumn === columnName) {
        isAsc = !this.isSortAsc
      }
      this.$emit('onSortOptionChange', columnName, isAsc)
    }
  }
}
</script>

<style lang="scss" scoped>
.inner_item {
  color: inherit;
  font-weight: inherit;
  position: relative;
  line-height: inherit;
  display: inline-block;
  vertical-align: middle;
  padding: 2px 0px;

  &[disabled] {
    cursor: default;
  }

  & > span {
    vertical-align: middle;
    display: inline-block;
  }

  i {
    vertical-align: middle;
  }
}

.sort {
  display: inline-block;
  width: 14px;
  box-sizing: border-box;
  margin-left: 4px;
  margin-right: 2px;
  vertical-align: middle;
  border-radius: 5px;
  transition: background-color 0.1s ease, box-shadow 0.1s ease;

  i.icon {
    float: left;
    opacity: 0.2;
    transition: opacity 0.15s ease;
  }

  &.active {
    &.asc {
      .icon--sort-asc {
        opacity: 1;
      }
    }

    &.desc {
      .icon--sort-desc {
        opacity: 1;
      }
    }
  }

  &:hover,
  &.active {
    background-color: #272727;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.146);
  }
}

.sort_icon {
  margin-left: 2px;
  vertical-align: middle;
}
</style>
